import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { FormField } from "@/components/ui/form"
import { RadioGroup, RadioGroupItem, RadioGroupLabel } from "@/components/ui/radio-group"
import { RecordExtractFormValues } from "@/modules/patients/detail/record-extract/lib/record-extract-schema"
import { EXPORT_SCOPE, ExportScope } from "@/modules/patients/detail/record-extract/types/record-extract-types"

const SCOPE_OPTIONS: { value: ExportScope; labelKey: string; testId: string }[] = [
  { value: EXPORT_SCOPE.full, labelKey: "patient.recordExtract.scope.fullFile", testId: "record-extract-scope-full" },
  {
    value: EXPORT_SCOPE.custom,
    labelKey: "patient.recordExtract.scope.customFilter",
    testId: "record-extract-scope-custom",
  },
]

type ExportScopeChipsProps = {
  disabled?: boolean
}

export const ExportScopeChips = ({ disabled }: ExportScopeChipsProps) => {
  const { t } = useTranslation()
  const { control } = useFormContext<RecordExtractFormValues>()

  return (
    <div className="flex flex-col gap-4">
      <p className="text-on-surface text-base font-medium">{t("patient.recordExtract.scope.title")}</p>
      <FormField
        control={control}
        name="scope"
        render={({ field }) => (
          <RadioGroup
            className="flex flex-wrap gap-2"
            value={field.value}
            disabled={disabled}
            onValueChange={field.onChange}
            data-testid="record-extract-scope">
            {SCOPE_OPTIONS.map((option) => (
              <RadioGroupItem key={option.value} value={option.value} data-testid={option.testId}>
                <RadioGroupLabel>{t(option.labelKey)}</RadioGroupLabel>
              </RadioGroupItem>
            ))}
          </RadioGroup>
        )}
      />
    </div>
  )
}
